import { render, staticRenderFns } from "./ComicList.vue?vue&type=template&id=32ba078e&"
import script from "./ComicList.vue?vue&type=script&lang=js&"
export * from "./ComicList.vue?vue&type=script&lang=js&"
import style0 from "./ComicList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports